module.exports = __webpack_public_path__ + "media/assets/icon_file-9823f1888d71f0ee1666aa985b5b62dd9e11c264af7c20094613e14ea16d41cb.svg";